<template>
  <div class="login-wrapper d-flex flex-column align-items-center justify-content-center">
    
    <!-- Logo da Instituição posicionada fora e acima do card para total destaque -->
    <div class="mb-4 text-center">
       <img v-if="base == 'UNIRON'" src="/img/icons/fundouniron.png" alt="Uniron Logo" class="uni-logo">
       <img v-if="base == 'UNINORTE'" src="/img/icons/logo.png" alt="Uninorte Logo" class="uni-logo">
    </div>

    <!-- Card de Login Modernizado (Seguindo o modern-design.css do sistema) -->
    <div class="modern-login-card shadow">
      
      <!-- Cabeçalho Azul Escuro (Garante que a logo branca do HelpDesk não suma) -->
      <div class="login-card-header text-center">
        <img src="/img/icons/helpdek.png" alt="HelpDesk Logo" class="helpdesk-logo">
      </div>
      
      <!-- Corpo do Card (Branco, moderno, limpo) -->
      <div class="login-card-body">
        <h5 class="text-center font-weight-bold mb-4" style="color: #344767;">Acesso ao Sistema</h5>
        
        <div class="form-group mb-4">
          <b-input-group class="modern-input-group">
            <b-input-group-prepend is-text>
              <b-icon icon="person-fill" class="text-primary"></b-icon>
            </b-input-group-prepend>
            <b-form-input
                v-model="dadosLogin.usuario"
                type="text"
                placeholder="Usuário"
                required
                autofocus
            ></b-form-input>
          </b-input-group>
        </div>
        
        <div class="form-group mb-4">
          <b-input-group class="modern-input-group">
            <b-input-group-prepend is-text>
              <b-icon icon="lock-fill" class="text-primary"></b-icon>
            </b-input-group-prepend>
            <b-form-input
                v-model="dadosLogin.senha"
                @keyup.enter="postLogin()"
                :type="typepassword"
                placeholder="Senha"
                required
            ></b-form-input>
            <b-input-group-append is-text style="cursor: pointer" @click="typepassword = typepassword === 'password' ? 'text' : 'password'">
              <b-icon :icon="typepassword === 'password' ? 'eye-fill' : 'eye-slash-fill'" class="text-muted"></b-icon>
            </b-input-group-append>
          </b-input-group>
        </div>

        <b-button
            @click="postLogin"
            variant="primary"
            block
            class="mt-4 rounded-pill shadow-sm btn-login"
        >
          <b-icon icon="box-arrow-in-right" class="mr-2"></b-icon> Entrar
        </b-button>
        
        <div class="text-center mt-3" v-if="mensagem">
          <b-alert show variant="danger" class="small py-2 border-0" style="border-radius: 8px;">{{ mensagem }}</b-alert>
        </div>
      </div>
    </div>
    
    <!-- Rodapé -->
    <div class="text-center mt-5">
       <p class="text-muted small font-weight-bold mb-2">Desenvolvido por TI-Uninorte.</p>
       <div v-show="deferredPrompt">
          <b-button pill variant="outline-primary" size="sm" @click="install()">
            <b-icon icon="download" class="mr-1"></b-icon> Instalar App
          </b-button>
       </div>
       <p class="version text-muted small mt-2 mb-0" style="cursor: pointer" @click="resetCache()">v{{ version }}</p>
    </div>

  </div>
</template>

<script>

export default {
  name: "Login",

  data() {
    return {
      dadosLogin: {usuario: '', senha: '', tokenNotification: ''},
      mensagem: "",
      logo: '',
      base: '',
      statusUsuario: false,
      typepassword: 'password',
      deferredPrompt: false
    };
  },

  computed: {
    version() {
      return this.$store.getters.appVersion;
    }
  },

  created() {
    this.validaBase();

    if (!window.matchMedia("(display-mode: standalone)").matches) {
      // Se o evento já foi capturado globalmente ou antes, reaproveitamos
      if (window.deferredPromptEvent) {
        this.deferredPrompt = window.deferredPromptEvent;
      }
      
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault(); 
        window.deferredPromptEvent = e; 
        this.deferredPrompt = e;
      });
    }
  },

  mounted() {
    localStorage.removeItem("token");
    localStorage.removeItem("linkAluno");
    localStorage.removeItem("linkOperador");
    localStorage.removeItem("tipo");
    localStorage.removeItem("wss");
    this.dadosLogin.usuario = localStorage.getItem("usuario");

  },

  methods: {
    // Metodos
    resetCache() {
      if (typeof caches !== 'undefined') {
        caches.keys().then(cacheNames => {
          cacheNames.forEach(cacheName => {
            caches.delete(cacheName);
          });
        })
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    install() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
      }
    },
    postLogin() {
      this.$loading(true);
      if (this.dadosLogin.usuario) {
        this.$http.post("/auth", this.dadosLogin).then(async (res) => {
          try {
            if (res.status == "200") {
              localStorage.setItem("token", res.data.tipo + " " + res.data.token);
              localStorage.setItem("usuario", res.data.usuarioLogado.nome);
              localStorage.setItem("perfil", res.data.usuarioLogado.perfil);
              localStorage.setItem("tipo", res.data.usuarioLogado.perfilId);
              localStorage.setItem('wss', res.data.usuarioLogado.linkOperador);
              await this.sleep(2000);

              if ([1, 2].find(x => x === parseInt(res.data.usuarioLogado.perfilId))) {
                return this.$router.push('/chamados-abertos');
              }

              this.$router.push('/bloco');
            } else {
              this.mensagem = res.data;
              this.dadosLogin = {usuario: '', senha: '', tokenNotification: ''};
              localStorage.setItem("token", "");
            }

          } catch (Error) {
            this.mensagem = "Falha de conexão";
          } finally {
            this.$loading(false);
          }
        });
      } else {
        this.mensagem = "Usuário ou Senha incorretos";
        this.dadosLogin = {usuario: '', senha: '', tokenNotification: ''};
        localStorage.setItem("token", "");
      }
    },

    async pedirPermissaoParaReceberNotificacoes() {
      try {
        await this.messaging.requestPermission();
        const token = await this.messaging.getToken();
        this.dadosLogin.tokenNotification = token;

        return token;
      } catch (error) {
        this.dadosLogin.token = '';
      }
    },
    validaBase() {
      switch (location.origin) {
        case 'https://ciaonline.uninorteac.edu.br' :
          this.logo = '/fundouninorte.png';
          this.base = 'UNINORTE'
          break;
        case 'https://ciaonlinehomolog.uninorteac.edu.br' :
          this.logo = '/fundouninorte.png';
          this.base = 'UNINORTE'
          break;
        case 'https://ciaonline.uniron.edu.br' :
          this.logo = '/fundouniron.png';
          this.base = 'UNIRON'
          break;
        case 'http://localhost:8080' :
          this.logo = '/fundouninorte.png';
          this.base = 'UNINORTE'
          break;
      }
    },


  },
};
</script>

<style>
/*
* ==========================================
* CUSTOM UTIL CLASSES & PREMIUM DESIGN
* ==========================================
*/
.login-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f4f6f9 0%, #e2e6f0 100%);
  font-family: 'Inter', 'Roboto', Lucida Sans Unicode, Lucida Grande, Geneva, Verdana, Arial, sans-serif;
  padding: 2rem;
  overflow-x: hidden;
}

.uni-logo {
  max-width: 220px;
  height: auto;
  object-fit: contain;
  /* Uma leve sombra para destacar a logo em cima do fundo claro */
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
}

.modern-login-card {
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  border: none;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0,0,0,0.08);
  animation: fadeUp 0.6s ease forwards;
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

/* O Cabeçalho Azul Escuro permite ver a logo original (que deve ter texto branco) */
.login-card-header {
  background: linear-gradient(135deg, #303f9f 0%, #1a237e 100%);
  padding: 35px 20px;
  border-bottom: 4px solid #f1c40f; /* Detalhe moderno */
}

.helpdesk-logo {
  max-width: 190px;
  height: auto;
  object-fit: contain;
}

.login-card-body {
  padding: 40px 35px;
}

/* Modern Input Groups matching system */
.modern-input-group .input-group-text {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-right: none;
  border-radius: 8px 0 0 8px;
  transition: all 0.3s ease;
}
.modern-input-group .form-control {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-left: none;
  box-shadow: none !important;
  border-radius: 0 8px 8px 0;
  height: 48px;
  font-size: 1rem;
  transition: all 0.3s ease;
}
.modern-input-group .input-group-append .input-group-text {
  border-left: none;
  border-right: 1px solid #e2e8f0;
  border-radius: 0 8px 8px 0;
}
.modern-input-group > .form-control:last-child {
  border-radius: 0 8px 8px 0;
}

/* Efeito de foco (Focus State) */
.modern-input-group:focus-within .input-group-text,
.modern-input-group:focus-within .form-control {
  border-color: #303f9f;
  background-color: #f8faff !important;
}
.modern-input-group:focus-within .input-group-prepend .input-group-text b-icon {
  color: #303f9f !important;
}

/* Botão Entrar */
.btn-login {
  background-color: #303f9f !important;
  border-color: #303f9f !important;
  height: 48px;
  font-size: 1.05rem;
  font-weight: 600;
  transition: all 0.3s ease;
}
.btn-login:hover {
  background-color: #1a237e !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(48, 63, 159, 0.3) !important;
}

@media (max-width: 576px) {
  .login-wrapper {
    padding: 1rem 0.5rem;
  }
  .login-card-body {
    padding: 25px 15px;
  }
  .modern-login-card {
    border-radius: 12px;
  }
}
</style>
